import {
  Button,
  Grid,
  Pagination,
  TextField,
  InputLabel,
  Select,
  FormControl,
  MenuItem
} from "@mui/material";
import BasicLayout from "../layout/BasicLayout";
import TrainingCreation from "../components/TrainingPage/trainingCreate/TrainingCreation";
import TrainingTableForServicer from "../components/TrainingPage/trainingTable/TrainingTableForServicer";
import { useEffect, useState } from "react";
import TrainingTableForAdmin from "../components/TrainingPage/trainingTable/TrainingTableForAdmin";
import TrainingTableForApprover from "../components/TrainingPage/trainingTable/TrainingTableForApprover";
import { useSelector } from "react-redux";
import useDebounce from "../hooks/trainingHooks/useDebounce";
import useFetchTrainings from "../hooks/trainingHooks/useFetchTrainings";
import { useNavigate } from "react-router-dom";
import {
  targetTableToDownload,
  pageLimit,
  fiscalYearOptions,
  UserRole,
} from "../utils/consts";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useFetchTrainingCredits from "../hooks/trainingHooks/useFetchTrainingCredits";
import TrainingTableForSupServicer from "../components/TrainingPage/trainingTable/TrainingTableForSupServicer";
import FileUploadModal from "../components/FileUpload/FileUploadModal";
import useUploadTrainings from "../hooks/trainingHooks/useUploadTrainings";
import FileUploadResultModal from "../components/FileUpload/FileUploadResultModal";
import TRSIIOptInModal from "../components/TrainingPage/trsiiOptIn/TRSIIOptInModal";
import useTRSIIOptIn from "../hooks/trainingHooks/useTRSIIOptIn";
import { toast } from "react-toastify";
import useFetchServicer from "../hooks/adminHooks/servicerMaintenance/useFetchServicer";
import PageHeader from "../components/pageHeader/PageHeader";


const TrainingPage = () => {

  const [order, setOrder] = useState('DESC')
  const [orderBy, setOrderBy] = useState('Submitted Date')

  const [searchKeyword, setSearchKeyword] = useState("");
  const [fiscalYear, setFiscalYear] = useState('');
  const debouncedSearchKeyword = useDebounce(searchKeyword, 300)

  const { updateOptIn } = useTRSIIOptIn();
  const navigate = useNavigate()

  const [page, setPage] = useState(1)
  const [limit] = useState(pageLimit)

  const {
     userName, userRole, servicerId, servicerMasterName, trsiiOptIn,
    optOutFlag, servicerCoordinatorName
  } = useSelector((state) => state.user)

  // const {data: trainngCredits} = useFetchTrainingCredits([
  //   'queryTrainingCredits'
  // ])

  const trsiiOptedOut = ((trsiiOptIn === 0 && optOutFlag === 1)|| (trsiiOptIn === 1 && optOutFlag === 1)||(trsiiOptIn === 0 && optOutFlag === 0));

  const getOptInText = () => {
    if (trsiiOptIn === 0 && optOutFlag === 1) {
      return 'Your Company has Opted Out of Public Scoring and approved by HUD. You Must Re-apply each Fiscal Year';
    } else if((trsiiOptIn === 1 && optOutFlag === 1)) {
      return 'Your Company applied for Public Scoring Opt Out but was Rejected by HUD';
    } 
    else if (optOutFlag === 0) {
      return trsiiOptIn === 0 ? 'Your Company has submitted for Public Scoring Opt Out and is Pending HUD Approval' : 'Your Company has currently not Opted out of Public Scoring. Only your Company Servicer Coordinator will be able to submit for HUD approval';
    }
    return "";
  };

  const optInText = getOptInText();


  const {data: servicerData, mutate: fetchServicerData} = useFetchServicer([
    "queryFetchServicer",
  ]);

  const [optInOption, setOptInOption] = useState(null);


  useEffect(() => {
    if (servicerData) {
      setOptInOption(servicerData.trsiiOptIn);
    }
  }, [servicerData]);

  useEffect(() => {
    if (servicerId) {
      fetchServicerData({servicerId});
    }
  }, [servicerId, fetchServicerData]);

  const {isLoading, data, error, isError, isFetching} = useFetchTrainings(
      ['queryAllTrainings', debouncedSearchKeyword, fiscalYear, orderBy, order, page, limit],
      page,
      limit,
      debouncedSearchKeyword,
      fiscalYear,
      order, orderBy
  )

  const {isUploading, uploadError, uploadFile, resp} = useUploadTrainings();

  useEffect(() => {
    setPage(1)
  }, [debouncedSearchKeyword])

  useEffect(() => {
    setPage(1);
  }, [orderBy, order])

  const searchHandler = (e) => {
    setSearchKeyword(e.target.value)
  }

  
  const fiscalYearFilterHandler = (e) => {
    setFiscalYear(e.target.value)
  }

  const renderTrainingTable = userRole => {
    switch (userRole){
      case UserRole.SERVICER:
        return <TrainingTableForServicer
            trainingList={data.trainingList}
            order={order}
            setOrder={setOrder}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
        />

      case UserRole.SERVICER_COORDINATOR:
        return <TrainingTableForSupServicer
            trainingList={data.trainingList}
            order={order}
            setOrder={setOrder}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
        />


      case UserRole.ADMIN:
        return <TrainingTableForAdmin
            trainingList={data.trainingList}
            order={order}
            setOrder={setOrder}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
        />


      case UserRole.APPROVER:
        return <TrainingTableForApprover
            trainingList={data.trainingList}
            order={order}
            setOrder={setOrder}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            page={page}
        />
    }
  }

  const renderTrainingInputWarnings = userRole => {
    if (
        userRole === UserRole.SERVICER ||
        userRole === UserRole.SERVICER_COORDINATOR
    ) {
      return (
          <Grid container direction="column" alignItems="center" sx={{mt: 2}} spacing={1}>
            <Grid item>
              <Typography variant="subtitle" color='black'>
                ECLASS trainings will be automatically updated Quarterly from the ECLASS system
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle" color='black'>
                Only input Webinar or Live Trainings here
              </Typography>
            </Grid>
          </Grid>
      )
    }
  }
  const renderTrainingCredits = userRole => {
    if (
        userRole === UserRole.SERVICER ||
        userRole === UserRole.SERVICER_COORDINATOR
    ) {
      return (
          <Grid container direction="column" alignItems="flex-end" sx={{mt: 2}} spacing={1}>
            <Grid item>
              {/*<Typography variant="subtitle">*/}
              {/*  Total Approved Trainings for User:{" "}*/}
              {/*  {trainingCredits?.approvedTrainingCount}*/}
              {/*</Typography>*/}
            </Grid>
            <Grid item>
              {/*<Typography variant="subtitle">*/}
              {/*  Total Approved Trainings for Servicer:{" "}*/}
              {/*  {trainingCredits?.totalApprovedTrainingCount}*/}
              {/*</Typography>*/}
            </Grid>
            {/*<Grid item><Typography variant='subtitle'>Total Annual Training Credit for Servicer for fiscal year till date (Max 1%): {trainingCredits?.scorePercentage}</Typography></Grid>*/}
          </Grid>
      )
    }
  }

  const renderOptOutApproverPage = () => {

    navigate("/optout");
    /*  return (
        <OptOutApproverPage servicerList={data.servicerList}/>
      );*/
  };

  const renderUserInfo = userRole => {
    if (
        userRole === UserRole.SERVICER ||
        userRole === UserRole.SERVICER_COORDINATOR
    ) {
      return (
        <>
         <Grid container direction='column' alignItems='flex-start' spacing={1}>
          <Typography variant="subtitle">
           {servicerMasterName && `FY2025 - TRS II Public Scoring: ${optInText}`}
          </Typography>
        </Grid>
       </>
      );
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTRSIIOptInModalOpen, setIsTRSIIOptInModalOpen] = useState(false);
  const [fileUploadResp, setFileUploadResp] = useState({
    total: 0,
    success: 0,
    failed: 0,
    errors: [],
  });
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFileUpload = async (file) => {
    // Perform file upload logic here
    //console.log("Uploading file:", file, email);
    const resp = await uploadFile(file);

    if (resp && resp.data) {
      setFileUploadResp(resp.data.uploadResp);
      setIsResultModalOpen(true);
    }
  };

  const handleResultModalClose = () => {
    setIsResultModalOpen(false);
  };

  const handleTRSIIOptInOpenModal = () => {
    setIsTRSIIOptInModalOpen(true);
  };

  const handleCloseTRSIIOptInModal = () => {
    setIsTRSIIOptInModalOpen(false);
  };

  const handleOptOutApprover = () => {
    setIsTRSIIOptInModalOpen(false);
  };


  const handleTRSIIOptIn = async () => {
    // Perform file upload logic here
    //console.log("Uploading file:", file, email);
    const updatedServicer = {
      id: servicerId,
      servicerMasterName,
      trsiiOptIn: !optInOption,
    };
    const resp = await updateOptIn(updatedServicer);
    if (resp && resp.data.message === "OK") {
      toast.success("Updated successfully");
      setOptInOption(!optInOption);
      window.location.reload();
    } else {
      toast.error("Update failed");
    }
  };

  const renderTRSIIOptInButton = (userRole) => {
    if (userRole === UserRole.SERVICER_COORDINATOR) {
      return (
        <Grid item xs={true} md={true}>
          <Button
            variant="contained"
            id="trsii-opt-in--modal-button"
            onClick={handleTRSIIOptInOpenModal}
            disabled={trsiiOptedOut}
          >{!optInOption ? "Public Scoring Opt Out" : "Public Scoring Opt In/Out"}
          </Button>
          <TRSIIOptInModal
            isOpen={isTRSIIOptInModalOpen}
            onClose={handleCloseTRSIIOptInModal}
            handleTRSIIOptIn={handleTRSIIOptIn}
            trsiiOptIn={optInOption}
          />
        </Grid>
      );
    }
   return <></>;
  };

  const renderOptOutButton = (userRole) => {
    if (userRole === UserRole.APPROVER) {
      return (
        <Grid item xs={true} md={true}>        
          <Grid>
            <Button
            id="trsii-opt-out-modal-button"
            variant="contained"
            onClick={renderOptOutApproverPage}
            > Approve Public Scoring Opt Out
            </Button>
          </Grid>
        </Grid>    
      );
    }
    return <></>;
  };

  const renderOptOut = (userRole) => {
    if (userRole === UserRole.ADMIN) {
      return (
        <Grid item xs={true} md={true}>        
          <Grid>
            <Button
            id="trsii-opt-out-modal-button"
            variant="contained"
            onClick={renderOptOutApproverPage}
            > Public Scoring Opt Out
            </Button>
          </Grid>
        </Grid>    
      );
    }
    return <></>;
  };


  const renderFileUploadButton = (userRole) => {
    if (userRole === UserRole.SERVICER_COORDINATOR || userRole === UserRole.APPROVER) {
      return (
          <Grid item xs={2} md={2}>
            <Grid>
              <Button
                id="upload-trainings-modal-button"
                variant="contained"
                onClick={handleOpenModal}
              >
                Upload Trainings
              </Button>
              <FileUploadModal
                  isOpen={isModalOpen}
                  onClose={handleCloseModal}
                  onFileUpload={handleFileUpload}
              />
              <FileUploadResultModal
                  responseData={fileUploadResp}
                  isOpen={isResultModalOpen}
                  onClose={handleResultModalClose}
              />            
            </Grid>
          </Grid>
      );
    }
    return <></>;
  };

  const renderFiscalYearFilter = (userRole) => {
    if (userRole === UserRole.APPROVER || userRole === UserRole.ADMIN || userRole === UserRole.SERVICER_COORDINATOR) {
      return (
          <Grid item xs={true} md={true}>
            <FormControl>
              <InputLabel id="fiscal-year">Fiscal Year</InputLabel>
              <Select sx={{ width: "150px" }}
                id="demo-simple-select"
                label="fiscal-year-label"
                labelId="fiscal-year"
                value={fiscalYear}
                onChange={fiscalYearFilterHandler}>
                {fiscalYearOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            </Grid>
      );
    }
    return <></>;
  }
    
  const rendertemplatedownloadButton = (userRole) => {
    if (userRole === UserRole.SERVICER_COORDINATOR || userRole === UserRole.APPROVER) {
      return (
        <Grid item xs={4} md={2}>
        <Grid>
        <Button
                  id="downloadtemplate-modal-button"
                  variant="contained"
                  href={"/files/hud_training_upload_template.xlsx"}
                  download={true}
                >
                Download Template
              </Button>
              </Grid>
              </Grid>
      );
    }
    return <></>;
  };
  const renderAddTrainingButton = userRole => {
    if (
        userRole === UserRole.SERVICER ||
        userRole === UserRole.SERVICER_COORDINATOR
    ) {
      return (
          <Grid item xs={4} md={1.5}>
            <TrainingCreation/>
          </Grid>
      )
    }
    return <></>
  }


  return (
      <BasicLayout>
        <Box display="flex" justifyContent="center" width="100%" marginBottom={5}>
          <Typography variant="h4">
            Training Reported for TRS II Year-End Bonus Credit{" "}
          </Typography>
        </Box>
        {data && renderTrainingInputWarnings(data.userRole)}
        <PageHeader
            userName={userName}
            userRole={userRole}
            servicerId={servicerId}
            servicerMasterName={servicerMasterName}
            servicerCoordinator={servicerCoordinatorName}
            currentPage={targetTableToDownload.trainingTable}
            searchKeyword={debouncedSearchKeyword}
            fiscalyear={fiscalYear}
            orderBy={orderBy}
            order={order}
            hasDownloadFeature={true}
        />
        <Grid container
              direction='column'
              alignItems='flex-start'
              sx={{mb: 5}}
              spacing={1}
        >
          <Grid item sx={{ml: 1}} spacing={1}>
            {data && renderUserInfo(data.userRole)}
          </Grid>
        </Grid>
        <Grid container
            alignItems="left"
            justifyContent="space-between"
            sx={{mb:2}}
            spacing={5}
        >
          {data && renderAddTrainingButton(data.userRole)}
          {data && renderFileUploadButton(data.userRole)}
          {data && rendertemplatedownloadButton(data.userRole)}
          {data && renderTRSIIOptInButton(data.userRole)}
          {data && renderOptOutButton(data.userRole)}
          {data && renderOptOut(data.userRole)}
          {data && renderFiscalYearFilter(data.userRole)}
          <Grid item xs={true} md={true} container justifyContent="flex-end">
            <TextField
                id="training-search-box"
                label="Search"
                variant="outlined"
                size="small"
                spacing="right"
                sx={{width: "fit-content"}}
                value={searchKeyword}
                onChange={(e) => searchHandler(e)}
            />
          </Grid>

        </Grid>

        <Box sx={{minHeight: "390px", minWidth: "900px", width: "fit-content" }}>
          {data && renderTrainingTable(data.userRole)}
        </Box>

        {data
            &&
            <Pagination
                sx={{mt: 2}}
                count={data.totalPage}
                page={page}
                onChange={(_e, v) => setPage(v)}
            />
        }

        {data && renderTrainingCredits(data.userRole)}

        <Box marginBottom={5}></Box>
      </BasicLayout>

  )
}

export default TrainingPage